class SectorHasSoilRepository {
  constructor(api) {
    this.api = api;
  }
  async getByIdSector(ID_SECTOR) {
    const raw = `
      SELECT * FROM CROP.SECTOR_HAS_SOIL
      WHERE ID_SECTOR = ${ID_SECTOR};
    `;

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });
    if( resp.length &&  resp[0].length){
      return resp[0][0];
    }
    return
  }

  async checkIfExistsSoil(ID_SOIL){
    const raw = `
    SELECT EXISTS ( SELECT * FROM CROP.SECTOR_HAS_SOIL
      WHERE ID_SOIL = ${ID_SOIL}) AS isExists;
  `
    const resp= await this.api.sql({
      data: {
        sql: raw
      }
    })

    if (resp[0].length) {
      let result = resp[0][0]
      return 'isExists' in result ? result.isExists : 0;
    }
    return;
  }

  async getByIdsFarm(IDS) {
    // length = 3
    let range=``

    IDS.map((id,i)=>{
      //Último item
      if(i === IDS.length-1){
        range+=id
      }else{
        range+=id+','
      }

    })
    const raw = `
      SELECT * FROM CROP.SECTOR_HAS_SOIL shs
      INNER JOIN CROP.SOIL cs
      WHERE shs.ID_SOIL = cs.ID AND
      shs.ID_SOIL IN (${range})
      `;
      // LIMIT 1;

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if( resp.length &&  resp[0].length){
      return resp[0];
    }
    return []
  }


  async getByIdSoil(ID_SOIL) {
    const raw = `
      SELECT * FROM CROP.SECTOR_HAS_SOIL
      WHERE ID_SOIL = ${ID_SOIL};
    `;

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if( resp.length &&  resp[0].length){
      return resp[0][0];
    }
    return
  }


  async save(ID_SECTOR, ID_SOIL) {

    const raw = `
      INSERT INTO CROP.SECTOR_HAS_SOIL(
        ID_SECTOR,
        ID_SOIL
      )VALUES(
        ${ID_SECTOR},
        ${ID_SOIL}
      );`


    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });
    if(resp.length && resp[0]){
      console.log(`[SectorHasSoil] - Sucesso ao salvar ID_SOIL ${ID_SOIL} atrelando ao setor ${ID_SECTOR}`)
    }
    return resp.length ? resp[0] : null;

  }

  async deleteByIdSector(ID_SECTOR) {
    const raw = `
      DELETE FROM CROP.SECTOR_HAS_SOIL
      WHERE ID_SECTOR = ${ID_SECTOR};
    `

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if(resp.length && resp[0]){
      console.log(`[SectorHasSoil] - Sucesso ao deletar setor ${ID_SECTOR} e solo atrelado a ele`)
    }

    return resp.length ? resp[0] : null;

  }

  async updateByIdSector(ID_SECTOR,ID_SOIL){
    const raw=`
      UPDATE CROP.SECTOR_HAS_SOIL
      SET ID_SOIL = ${ID_SOIL}
      WHERE ID_SECTOR = ${ID_SECTOR};
    `

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    return resp
  }



}

export {
  SectorHasSoilRepository
};
